import { extractFirstText } from '@farmnet/helper';

angular.module('cfn').directive('appIcon', appIcon);

appIcon.$inject = [
  '$rootScope',
  '$filter',
];

function appIcon(
    $rootScope,
    $filter,
) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      name: '@',
      color: '@',
      category: '@',
      title: '@',
      link: '@',
      webappLoaderLink: '@',
      external: '@',
      partner: '@',
      // if expression evaluates to true, shows a not bought module message
      nonauthorized: '@',
      // if expression evaluates to true, shows a feature not ready message
      unavailable: '@',
      icon: '@',
      iconPath: '@',
      fnIcon: '@',
      resizeable: '@',
      // to be used instead of hasright-attribute when using ng-click instead of href
      permission: '@',
      beta: '@'
    },
    compile: function(element, attrs) {
      if (!attrs.resizeable) {
        attrs.resizeable = 'true';
      }
    },
    controller: appIconController,
    template: function(element, attrs) {
      var wildcards = {};

      if (!attrs.icon) {
        // wildcards.href = "href='javascript:void(0)'";
        wildcards.href = attrs.link ? ` ng-href="{{href}}" ng-attr-target="{{target}}"` : attrs.webappLoaderLink ? ` href="${attrs.webappLoaderLink}"` : ` href="javascript:void(0)"`;
      } else {
        wildcards.href = attrs.link ? ` ng-href="{{href}}" ng-attr-target="{{target}}"` : attrs.webappLoaderLink ? ` href="${attrs.webappLoaderLink}"` : '';
      }

      // TODO:
      // [] Track only if the user has permissions
      // [] `attrs.permission` seems to *not* be used anymore
      if (attrs.permission) {
        wildcards.permission = `hasright="${attrs.permission}"`;
      } else {
        wildcards.permission = '';
      }

      if (attrs.iconPath) {
        wildcards.iconPath = `iconPath + '`;
      } else {
        wildcards.iconPath = `'img/icons/`;
      }

      var isNameAndIconPath =
          attrs.name != null &&
          attrs.name !== '' &&
          attrs.iconPath &&
          !attrs.icon;
      var isName =
          attrs.name != null &&
          attrs.name !== '' &&
          !attrs.iconPath &&
          !attrs.icon;
      // var isIcon = attrs.icon != null && attrs.icon !== '';
      var isPartner = attrs.partner != null && attrs.partner !== '';

      // generate icon paths for template
      var iconPathSource = isNameAndIconPath ? wildcards.iconPath + `white/' + ( name | lowercase ) + '.png'` : `''`;
      var nameSource = isName ? `'` + $filter('iconPath')(attrs.name) + `white/' + ( name | lowercase ) + '.png'` : `''`;
      var partnerSource = isPartner ? `'img/partner/subicon/' + ( partner | lowercase ) + '.png'` : `''`;

      // handle icon clicks
      wildcards.clickHandler = ` ng-click="
        onIconClick(
          $event,
          {
            name: '${attrs.name}',
            path: '${attrs.link}',
            titleKey: '${extractFirstText(attrs.title)}',
            requiredLicense: '${attrs.dRequiresProductLicense}',
            requiredRight: '${attrs.hasright}'
          }
        )" ng-class="{
        inactive: inactive == 'true',
        norights: norights == 'true',
        nonauthorized: nonauthorized == 'true',
        unavailable: unavailable == 'true',
        resizeable: resizeable == 'true'
      }" `;

      return (
          `<a class="app-icon" ${wildcards.href + wildcards.clickHandler + wildcards.permission}>
          <div class="appItem">
            <div class="appIcon roundBorder bg_{{color || name | lowercase}} bg_{{color || name}} app-icon-bg--{{ category }}">
              <div ng-if="beta" class="banner">
                <div>Beta</div>
                <div></div>
              </div>
              <!-- ng-if (do not show img-tag at all) and ng-src (do not load corrupt img-srcs leading to 404) -->
              <img ng-if="name && iconPath && !icon && !fnIcon" class="appIconInner" ng-src="{{name && iconPath && !icon ? ${iconPathSource} : ''}}"/>
              <img ng-if="name && !iconPath && !icon && !fnIcon" class="appIconInner" ng-src="{{name && !iconPath && !icon ? ${nameSource} : ''}}"/>
              <span ng-if="icon && !fnIcon" class="appIconInner {{icon}}"></span>
              <img ng-if="icon && partner && !fnIcon" class="appPartnerInner" ng-src="{{icon && partner ? ${partnerSource} : ''}}"/>
              <div ng-if="fnIcon" class="app-icon-fn-icon">
                <fn-icon icon-name="{{ fnIcon }}" color-class="white"></fn-icon>
              </div>
            </div>
            <div class="text" ng-if="title.length > 0">{{title}}</div>
          </div>
          <div ng-transclude></div>
        </a>`
      );
    }
  };
}

appIconController.$inject = [
  '$scope',
  '$routeParams',
  '$location',
  '$rootScope',
  'CfnFeatureAvailabilityService',
  'fnwNavigationService'
];
function appIconController(
    $scope,
    $routeParams,
    $location,
    $rootScope,
    CfnFeatureAvailabilityService,
    fnwNavigationService,
) {
  $scope.$rootScope = $rootScope;
  $scope.onIconClick = (clickEvent, tileData) => {
    const isUnavailable = $scope.unavailable === 'true';
    // TODO: Deprecated due to requiresProductLicense directive?
    const isNotBought = $scope.nonauthorized === 'true';
    const isWebappLoader = !!$scope.webappLoaderLink;

    switch (true) {
      case isUnavailable:
        CfnFeatureAvailabilityService.showDialog();
        clickEvent.preventDefault();
        break;
      case isNotBought:
        $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
                'fe.booking.error',
                'Dieser Baustein wurde noch nicht gekauft!'
            ),
            'error'
        );
        clickEvent.preventDefault();
        break;
      case isWebappLoader:
        fnwNavigationService.navigateToServiceByUrl($scope.webappLoaderLink);
        clickEvent.preventDefault();
        break;
    }
  };

  if (
      angular.isDefined($scope.external) &&
      $scope.external === 'true'
  ) {
    $scope.href = $scope.link;
    $scope.target = '_blank';
  } else {
    $scope.href = '#/' + $scope.link;
  }
}
